// Contains card-ids that have been added to compare by the user.
export var CompareCardIdListCookieName = 'nw_compare'; // Contains card objects. TODO: Do away with this cookie

export var CompareCardDataCookieName = 'nw_compare_card_data'; // Contains cards that have been removed by the user.

export var CompareCardRemovedLoopbackCookieName = 'nw_compare_card_removed_loopback_ids';